var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowGreenCircleActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2FA136;}\n\t.st1{fill:#FFFBF0;}\n\t.st2{fill:none;stroke:#094E0B;stroke-width:2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,1L13,1c6.6,0,12,5.4,12,12l0,0c0,6.6-5.4,12-12,12l0,0C6.4,25,1,19.6,1,13l0,0C1,6.4,6.4,1,13,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.8,13.8h8.6l-3.8,3.9c-0.3,0.3-0.3,0.8,0,1.1s0.8,0.3,1.1,0l5.1-5.2c0.3-0.3,0.3-0.8,0-1.1l-5.1-5.2 c-0.3-0.3-0.8-0.3-1.1,0c-0.3,0.3-0.3,0.8,0,1.1l3.8,3.9H7.8C7.3,12.2,7,12.6,7,13S7.3,13.8,7.8,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13,1L13,1c6.6,0,12,5.4,12,12l0,0c0,6.6-5.4,12-12,12l0,0C6.4,25,1,19.6,1,13l0,0C1,6.4,6.4,1,13,1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreenCircleActive);
export default __webpack_public_path__ + "static/media/arrow-green-circle-active.31ddc710ad5f0817c30100f520d55e56.svg";
export { ForwardRef as ReactComponent };